module.exports = "/images/square-facebook.svg?349d876b8650d6e3499e85b67429366b";